import SystemSettings from "components/organisms/SystemSettings/SystemSettings";

export default function GlobalSettingsTemplate() {
  return <SystemSettings />;
}
